import React from "react";
import { Col, Form } from "react-bootstrap";
import { FILTER_OPTIONS } from "../utils/filterConfig";

const FilterDropdown = ({ selectedValue, handleSelectChange }) => {
  return (
    <Col sm={12} md={5}>
      <Form.Select
        className="location-filter__form-select mb-2"
        aria-label="Select a category"
        value={selectedValue}
        onChange={handleSelectChange}
        id="map-filter"
      >
        <option value="select">Select a filter:</option>
        {FILTER_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </Col>
  );
};

export default FilterDropdown;
